import { IRootState } from 'src/state/types';

/**
 * Returns the active params from the store.
 */
export function selectActive(state: IRootState) {
  return state.active;
}
